import { render, staticRenderFns } from "./Cooking.vue?vue&type=template&id=04f444ee&scoped=true"
import script from "./Cooking.vue?vue&type=script&lang=js"
export * from "./Cooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f444ee",
  null
  
)

export default component.exports